export enum GrowthbookFlagsEnum {
  Sms = 'Sms',
  WhiteLabel = 'WhiteLabel',
  Assignment = 'Assignment',
  Website = 'Website',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
